export const routeName = 'legal-disclaimer';
export const slugs: Record<string, string> = {
	en: 'legal-disclaimer',
	es: 'aviso-legal',
	ca: 'avis-legal',
	it: 'note-legali',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-02-24' };
